import { render, staticRenderFns } from "./ProjectLabel.vue?vue&type=template&id=859ab28c"
import script from "./ProjectLabel.vue?vue&type=script&lang=ts"
export * from "./ProjectLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports